export * from './index.component'